<div class="addresses-card">
    <div class="addresses-header">
        <div>
            <span class="addresses-eyebrow">ENVÍOS</span>
            <h2>Mis direcciones</h2>
            <p>Administra las direcciones donde recibes tus pedidos.</p>
        </div>
        <button class="addresses-add-button" mat-raised-button type="button" (click)="addAddress()">
            AGREGAR DIRECCIÓN
        </button>
    </div>
    <!-- SIN DIRECCIONES -->
    <div class="addresses-empty" *ngIf="dataAddresses.length == 0">
        <h3>Sin direcciones de envío</h3>
        <p>
            Actualmente no tienes direcciones de envío guardadas.
            Puedes agregar una nueva dirección utilizando el botón
            de arriba.
        </p>
    </div>

    <!-- DIRECCIONES -->
    <div class="addresses-list" *ngIf="dataAddresses.length > 0">
        <div class="address-item" *ngFor="let address of dataAddresses">
            <div class="address-content">
                <div class="address-main">
                    <span class="address-label">
                        DIRECCIÓN
                    </span>
                    <span class="address-value address-street">
                        {{ address.street }}
                        {{ address.ext_number }}
                    </span>
                </div>
                <div class="address-grid">
                    <div class="address-data">
                        <span class="address-label">
                            {{ address.locality.zone_type }}
                        </span>
                        <span class="address-value">
                            {{ address.locality.name }}
                        </span>
                    </div>
                    <div class="address-data">
                        <span class="address-label">
                            CÓDIGO POSTAL
                        </span>
                        <span class="address-value">
                            {{ address.zip_code }}
                        </span>
                    </div>
                    <div class="address-data">
                        <span class="address-label">
                            CIUDAD
                        </span>
                        <span class="address-value">
                            {{ address.municipality.name }}
                        </span>
                    </div>
                    <div class="address-data">
                        <span class="address-label">
                            ESTADO
                        </span>
                        <span class="address-value">
                            {{ address.state.name }}
                        </span>
                    </div>
                    <div class="address-data">
                        <span class="address-label">
                            RECIBE
                        </span>
                        <span class="address-value">
                            {{ address.receiving_name }}
                        </span>
                    </div>
                </div>
                <div class="address-actions">
                    <button class="address-action-button" mat-stroked-button type="button"
                        (click)="editAddress(address)">
                        <mat-icon>edit</mat-icon>
                        Editar
                    </button>
                    <button class="address-delete-button" mat-stroked-button type="button"
                        *ngIf="dataAddresses.length > 1" (click)="deleteAddress(address.id)">
                        <mat-icon>delete_outline</mat-icon>
                        Eliminar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>